import _fileAttachments from '../_internal/reducers/fileAttachments';
export const fileAttachments = _fileAttachments;